export class FirstTime{
    transactionId:string;
    fullName:string;
    dateOfBirth:string;
    phoneNumber:string;
}